<template>
  <header
    class="app-header booking-brand-surface"
    :class="{
      'app-header--admin': headerTitle,
      'app-header--logo-only': !showCenterTitle,
    }"
    :style="headerStyle"
  >
    <div class="app-header__inner">
      <div class="app-header__brand">
        <v-img
          class="nav-logo nav-logo--left"
          :src="displayLogo"
          alt="Home"
          contain
          @click="navigateHome()"
        />
      </div>

      <div v-if="showCenterTitle" class="app-header__title">
        <h1 v-if="headerTitle" :style="{ color: adminTitleColor }">
          {{ admintitle + " Admin Module" }}
        </h1>
        <h1 v-else :style="{ color: titleColor }">{{ title }}</h1>
      </div>

      <div class="app-header__partner">
        <v-img
          v-if="rightLogo !== ''"
          class="nav-logo nav-logo--right"
          :src="rightLogo"
          alt=""
          max-height="68"
          contain
        />
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions } from "vuex";
import { getAdminGeneralSettings, getBookingGeneral } from "../../../store/vuexStore";
import { applyBookingTheme, getBrandColor, getContrastTextColor } from "@/utils/bookingTheme.js";
import * as ENV from "@/config.js";
import FCCLOGO from "@/assets/FCCLOGO-light.png";

export default {
  props: {
    headerTitle: { type: [String, Boolean], default: false },
    bookingHeaderColor: { type: String, default: "" },
    /** Show centre venue title (home-style). Booking flow pages use logo only. */
    showTitle: { type: Boolean, default: false },
  },
  data() {
    return {
      image: FCCLOGO,
      title: "",
      admintitle: "",
      adminHeaderColor: "",
      leftLogo: "",
      rightLogo: "",
    };
  },
  computed: {
    bookingGeneral() {
      const facilityKey = `${ENV.VUE_APP_FACILITY}_booking`;
      return (
        this.$store.state[facilityKey]?.bookingGeneral ||
        this.$store.state.tennis_booking?.bookingGeneral ||
        {}
      );
    },
    brandColor() {
      if (this.headerTitle) return this.adminHeaderColor;
      return getBrandColor(this.bookingGeneral);
    },
    titleColor() {
      return getContrastTextColor(this.brandColor);
    },
    adminTitleColor() {
      return getContrastTextColor(this.adminHeaderColor);
    },
    showCenterTitle() {
      return Boolean(this.headerTitle) || this.showTitle;
    },
    displayLogo() {
      const custom = (this.leftLogo || "").trim();
      return custom || this.image;
    },
    headerStyle() {
      return {
        backgroundColor: this.brandColor,
      };
    },
  },
  watch: {
    bookingGeneral: {
      handler(general) {
        if (this.headerTitle || !general || !Object.keys(general).length) {
          return;
        }
        applyBookingTheme(general);
        this.title = general?.header?.title || "Tennis Booking App";
        this.leftLogo = general?.header?.leftLogo || "";
        this.rightLogo = general?.header?.rightLogo || "";
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      adminGetGeneralSettings: `${ENV.VUE_APP_FACILITY}_admin/adminGetGeneralSettings`,
    }),
    navigateHome() {
      this.$router.push({ path: `/bookingapp/${ENV.VUE_APP_FACILITY}/` });
    },
  },
  created() {
    const admingenralSettings = getAdminGeneralSettings();

    this.adminHeaderColor = admingenralSettings?.color || "#00509e";
    this.admintitle = admingenralSettings?.header?.title || "Admin Module";

    if (this.headerTitle) {
      this.leftLogo = admingenralSettings?.header?.leftLogo || "";
      this.rightLogo = admingenralSettings?.header?.rightLogo || "";
    } else {
      const bookingGeneral = getBookingGeneral() || {};
      this.leftLogo = bookingGeneral?.header?.leftLogo || "";
      this.rightLogo = bookingGeneral?.header?.rightLogo || "";
      if (bookingGeneral?.header?.title) {
        this.title = bookingGeneral.header.title;
      }
    }
  },
};
</script>
<style src="./header.css"></style>
